import { stepChangesToYourJourneyLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const changesToYourJourneyExpensesBL = mapToMedicalExpensesBL(data);
  const changesToYourJourneyExpensesAL = mapToMedicalExpensesAL(data);
  return [...changesToYourJourneyExpensesBL, ...changesToYourJourneyExpensesAL];
}

function mapToMedicalExpensesBL(data) {
  if (data.haveYouCanceledOrChangedYourJourneyBeforeLeaving !== 'true') {
    return [];
  }

  if (data.changesToYourJourneyBeforeLeavingExpenseItems1.length < 1 && data.changesToYourJourneyBeforeLeavingExpenseItems2.length < 1 && data.changesToYourJourneyBeforeLeavingExpenseItems3.length < 1 && data.changesToYourJourneyBeforeLeavingExpenseItems4.length < 1 && data.changesToYourJourneyBeforeLeavingExpenseItems4PI.length < 1) {
    return [];
  }

  let claimCode = expenseLookup.haveYouCanceledOrChangedYourJourneyBeforeLeaving.claimCode;
  const expenses = [];
  if (data.wereYouDelayedWhileTravelingToASpecialEvent === 'true' && data.changesToYourJourneyBeforeLeavingExpenseItems1.length > 0) {
    claimCode = expenseLookup.wereYouDelayedWhileTravelingToASpecialEvent.claimCode;
    data.changesToYourJourneyBeforeLeavingExpenseItems1.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode);
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson === 'false' && data.changesToYourJourneyBeforeLeavingExpenseItems2.length > 0) {
    claimCode = expenseLookup.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson.claimCode;
    data.changesToYourJourneyBeforeLeavingExpenseItems2.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode);
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition !== '' && data.changesToYourJourneyBeforeLeavingExpenseItems3.length > 0) {
    claimCode = data.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'true'
                ? expenseLookup.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionYes.claimCode
                : expenseLookup.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionNo.claimCode;
    data.changesToYourJourneyBeforeLeavingExpenseItems3.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode);
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.wereYouChargedACancellationFeeByTheTravelAgent === 'true' && data.changesToYourJourneyBeforeLeavingExpenseItems4.length > 0) {
    claimCode = expenseLookup.wereYouChargedACancellationFeeByTheTravelAgent.claimCode;
    data.changesToYourJourneyBeforeLeavingExpenseItems4.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode);
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.wereYouChargedACancellationFeeByTheTravelAgentPI === 'true' && data.changesToYourJourneyBeforeLeavingExpenseItems4PI.length > 0) {
    claimCode = expenseLookup.wereYouChargedACancellationFeeByTheTravelAgent.claimCode;
    data.changesToYourJourneyBeforeLeavingExpenseItems4PI.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode);
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  return expenses;
}

function mapToMedicalExpensesAL(data) {
  if (data.haveYouChangedYourJourneyAfterLeaving !== 'true') {
    return [];
  }

  if (data.changesToYourJourneyAfterLeavingExpenseItems1.length < 1 && data.changesToYourJourneyAfterLeavingExpenseItems2.length < 1 && data.cuttingYourTripShortToReturnHomeExpenseItems.length < 1 && data.travelInterruptionExpenseItems.length < 1 && data.resumingYourTripBackOverseasItems.length < 1) {
    return [];
  }

  let claimCode = expenseLookup.haveYouChangedYourJourneyAfterLeaving.claimCode;
  const expenses = [];
  if (data.wereYouDelayedWhileTravelingToASpecialEventAL === 'true' && data.changesToYourJourneyAfterLeavingExpenseItems1.length > 0) {
    claimCode = expenseLookup.wereYouDelayedWhileTravelingToASpecialEventAL.claimCode;
    data.changesToYourJourneyAfterLeavingExpenseItems1.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode);
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'true' && data.changesToYourJourneyAfterLeavingExpenseItems2.length > 0) {
    claimCode = expenseLookup.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL.claimCode;
    data.changesToYourJourneyAfterLeavingExpenseItems2.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode);
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'false' && (data.cuttingYourTripShortToReturnHomeExpenseItems.length > 0 || data.travelInterruptionExpenseItems.length > 0 || data.resumingYourTripBackOverseasItems.length > 0)) {
    const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
      ? data.whatExpensesAreYouClaimingFor.toJS()
      : data.whatExpensesAreYouClaimingFor || [];

    if (expensesSelected.includes('Cutting your trip short to return home')) {
      claimCode = expenseLookup.cuttingYourTripShortToReturnHome.claimCode;
      data.cuttingYourTripShortToReturnHomeExpenseItems.forEach(
        (item) => {
          const expense = mapExpenseItem(item, data, claimCode);
          if (!!expense) {
            expenses.push(expense);
          }
          const reimburseExpense = mapReimbursement(item, data, claimCode);
          if (!!reimburseExpense) {
            expenses.push(reimburseExpense);
          }
        }
      );
    }

    if (expensesSelected.includes('Travel Interruption')) {
      const travelInterruptionExpensesSelected = !!data.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption && typeof data.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS === 'function'
      ? data.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS()
      : data.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption || [];
      claimCode = expenseLookup.travelInterruption.claimCode;
      data.travelInterruptionExpenseItems.forEach(
        (item) => {
          const expense = mapExpenseItem(item, data, claimCode);
          if (!!expense) {
            expenses.push(expense);
          }
          const reimburseExpense = mapReimbursement(item, data, claimCode);
          if (!!reimburseExpense) {
            expenses.push(reimburseExpense);
          }
        }
      );

      if (travelInterruptionExpensesSelected.includes('Pet boarding facility')) {
        claimCode = expenseLookup.petBoardingFacility.claimCode;
        data.petBoardingFacilityExpenseItems.forEach(
          (item) => {
            const expense = mapExpenseItem(item, data, claimCode);
            if (!!expense) {
              expenses.push(expense);
            }
            const reimburseExpense = mapReimbursement(item, data, claimCode);
            if (!!reimburseExpense) {
              expenses.push(reimburseExpense);
            }
          }
        );
      }

      if (travelInterruptionExpensesSelected.includes('Childcare expenses')) {
        claimCode = expenseLookup.childCareExpenses.claimCode;
        data.childCareExpensesExpenseItems.forEach(
          (item) => {
            const expense = mapExpenseItem(item, data, claimCode);
            if (!!expense) {
              expenses.push(expense);
            }
            const reimburseExpense = mapReimbursement(item, data, claimCode);
            if (!!reimburseExpense) {
              expenses.push(reimburseExpense);
            }
          }
        );
      }
    }

    if (expensesSelected.includes('Resuming your trip back overseas')) {
      claimCode = expenseLookup.resumingYourTripBackOverseas.claimCode;
      data.resumingYourTripBackOverseasItems.forEach(
        (item) => {
          const expense = mapExpenseItem(item, data, claimCode);
          if (!!expense) {
            expenses.push(expense);
          }
          const reimburseExpense = mapReimbursement(item, data, claimCode);
          if (!!reimburseExpense) {
            expenses.push(reimburseExpense);
          }
        }
      );
    }
  }

  if (data.didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL === 'false' && (data.cuttingYourTripShortToReturnHomeExpenseItems.length > 0 || data.travelInterruptionExpenseItems.length > 0 || data.resumingYourTripBackOverseasItems.length > 0)) {
    const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
      ? data.whatExpensesAreYouClaimingFor.toJS()
      : data.whatExpensesAreYouClaimingFor || [];

    if (expensesSelected.includes('Cutting your trip short to return home')) {
      claimCode = expenseLookup.cuttingYourTripShortToReturnHome.claimCode;
      data.cuttingYourTripShortToReturnHomeExpenseItems.forEach(
        (item) => {
          const expense = mapExpenseItem(item, data, claimCode);
          if (!!expense) {
            expenses.push(expense);
          }
          const reimburseExpense = mapReimbursement(item, data, claimCode);
          if (!!reimburseExpense) {
            expenses.push(reimburseExpense);
          }
        }
      );
    }

    if (expensesSelected.includes('Resuming your trip back overseas')) {
      claimCode = expenseLookup.resumingYourTripBackOverseas.claimCode;
      data.resumingYourTripBackOverseasItems.forEach(
        (item) => {
          const expense = mapExpenseItem(item, data, claimCode);
          if (!!expense) {
            expenses.push(expense);
          }
          const reimburseExpense = mapReimbursement(item, data, claimCode);
          if (!!reimburseExpense) {
            expenses.push(reimburseExpense);
          }
        }
      );
    }

    if (expensesSelected.includes('Travel Interruption')) {
      const travelInterruptionExpensesSelected = !!data.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption && typeof data.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS === 'function'
      ? data.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS()
      : data.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption || [];
      claimCode = expenseLookup.travelInterruption.claimCode;
      data.travelInterruptionExpenseItems.forEach(
        (item) => {
          const expense = mapExpenseItem(item, data, claimCode);
          if (!!expense) {
            expenses.push(expense);
          }
          const reimburseExpense = mapReimbursement(item, data, claimCode);
          if (!!reimburseExpense) {
            expenses.push(reimburseExpense);
          }
        }
      );

      if (travelInterruptionExpensesSelected.includes('Pet boarding facility')) {
        claimCode = expenseLookup.petBoardingFacility.claimCode;
        data.petBoardingFacilityExpenseItems.forEach(
          (item) => {
            const expense = mapExpenseItem(item, data, claimCode);
            if (!!expense) {
              expenses.push(expense);
            }
            const reimburseExpense = mapReimbursement(item, data, claimCode);
            if (!!reimburseExpense) {
              expenses.push(reimburseExpense);
            }
          }
        );
      }

      if (travelInterruptionExpensesSelected.includes('Childcare expenses')) {
        claimCode = expenseLookup.childCareExpenses.claimCode;
        data.childCareExpensesExpenseItems.forEach(
          (item) => {
            const expense = mapExpenseItem(item, data, claimCode);
            if (!!expense) {
              expenses.push(expense);
            }
            const reimburseExpense = mapReimbursement(item, data, claimCode);
            if (!!reimburseExpense) {
              expenses.push(reimburseExpense);
            }
          }
        );
      }
    }
  }

  return expenses;
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursement(item, formData, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountCreditedOrRefunded || !item.currencyCreditedOrRefunded || item.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem} (Reimbursement)`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: `${item.amountCreditedOrRefunded * -1}`,
    currency: item.currencyCreditedOrRefunded,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepChangesToYourJourneySCTIDataMapper.js